
<ion-tab-bar slot="bottom">
  <ion-tab-button
  (click)="navigateToConversation($event)"
    tab=""
    tooltip="{{'Conversations' | translation}}"
    [displayTouchscreen]="displaytooltip"
    [display]=displaytooltip

  >
    <ion-icon name="chatbubbles"></ion-icon>
  </ion-tab-button>
  <ion-tab-button
  (click)="navigateToGroups($event)"
  tab=""
    
  tooltip="{{'GroupChats' | translation}}"
    [displayTouchscreen]="displaytooltip"
    [display]=displaytooltip

  >
    <i class="fas fa-users"></i>
  </ion-tab-button>
  <ion-tab-button
    tab="tab-disciples"
    (click)="navigateToDisciples($event)"
    tooltip="{{'Disciples' | translation}}"
    [displayTouchscreen]="displaytooltip"
    [display]=displaytooltip

  >
    <i class="fas fa-hands-helping"></i>
  </ion-tab-button>
  <ion-tab-button
  (click)="navigateToLeader($event)"
  tab="tab-profile"
    tooltip="{{'MessageLeader' | translation}}"
    [displayTouchscreen]="displaytooltip"
    [display]=displaytooltip

  >
  <i class="pty-icon-start fas fa-fw  fa-envelope"></i>
  </ion-tab-button>
</ion-tab-bar>
